/**
 * @file layerRules.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Vue from 'vue'
import * as R from 'ramda'
import {v4} from 'uuid'
import queryBuilder from '../filter/queryBuilder'
import mapActions from '../map/MapActions'
import messenger from '../messenger/messenger'
import {ColumnChooser} from '../../service/ColumnChooser'
import {DataViz} from '../../service/DataViz'
import {Expression} from '../../service/Expression'
import {Layer} from '../../service/Layer'
import {QueryBuilder} from '../../service/QueryBuilder'
import {Postgrest} from '../../service/Postgrest'
import {Table} from '../../service/Table'
import {Category} from '../../service/Category'
import MapConstants from '../common/MapConstants'

export default {
  data: () => ({
    categoryService: Category.build({}),
    dataVizService: DataViz.build({}),
    dataService: Postgrest.build({}),
    expressionService: Expression.build({}),
    layerService: Layer.build({}),
    queryService: QueryBuilder.build({}),
    tableService: Table.build({}),
    templateService: ColumnChooser.build({}),
    gdIdEventSetor: 'c82d5b42-c862-11ea-87d0-0242ac130003',
    basePk: null,
    targetPk: null,
    baseLayer: null,
    targetLayer: null,
    /* layerType: 'cluster', */
    nativeType: 'circle',
    zoomThreshold: 13
  }),
  created () {
    try {
      if (this.layer === null) return
      const layer = this.layer.object.layer
      const layer2 = this.layer2 !== null && this.layer2 !== undefined ? this.layer2.object.layer : null
      // this.layerType = layer.jbData.config.datavis.type || 'cluster'
      this.nativeType = layer.jbData.config.datavis.native || 'circle'
      this.baseLayer = layer
      this.targetLayer = layer2 || layer
    } catch (e) {
    }
  },
  mounted () {
  },
  computed: {
    canGroupBy: function () {
      if (!this.baseLayer) return false
      if (this.baseLayer.jbData.config.datavis.native === 'fill' && this.baseLayer.gdIdParent !== this.gdIdEventSetor) return true
      if (this.targetLayer === null || this.targetLayer === undefined) return false
      if (this.baseLayer.jbData.config.datavis.native !== this.targetLayer.jbData.config.datavis.native) return true
      if (this.baseLayer.gdIdParent === this.targetLayer.gdIdEvent) return false
      return this.baseLayer.gdIdParent !== this.targetLayer.gdIdEvent
    },
    canUseAreaStyle: function () {
      if (this.nativeType === 'fill') return true
      if (!this.targetLayer) return false
      return this.targetLayer.jbData.config.datavis.type === 'fill'
    }
  },
  watch: {
    targetLayer: function (n, o) {
      if (o !== null && o.gdIdEvent !== n.gdIdEvent) {
        this.targetLayerChanged(n)
      } else if (n !== null) {
        this.targetLayerChanged(n)
      }
    }
  },
  methods: {
    addGeometryRule: function (rule, query = null) {
      return this.addSpatialFilter(rule, query)
      // Preservando o código original até a validação (Ferraz)
      /*
      if (!R.is(Object, rule)) throw new Error('Esperado um objeto contendo a rule')
      if (query === null && !this.baseHasFilter()) throw new Error(`BaseLayer não é filtro: Impossível continuar`)
      if (query === null) query = this.baseLayer.jbQuery.query.Postgresql
      try {
        let columnIndex = -1
        let groupIndex = 0
        let groupRulesLength = 0
        const rules = (this.useGroupBy() && !this.isAggregatedLayer()) ? query.having : query.rules
        for (let i = 0; i < rules.length; i++) {
          let group = rules[i]
          columnIndex = group.rules.findIndex(c => c.id === rule.rules[0].id && c.type === 'geometry' && c.flow === rule.flow)
          if (columnIndex !== -1) {
            groupIndex = i
            groupRulesLength = group.rules.length
          }
        }
        if (columnIndex !== -1) {
          console.info(`Coluna de geometria já existe na coleção: ${columnIndex}`)
          if (groupRulesLength === 1) {
            if (this.useGroupBy() && !this.isAggregatedLayer()) {
              query.having.splice(columnIndex, 1)
            } else {
              query.rules.splice(groupIndex, 1)
            }
          } else {
            if (this.useGroupBy() && !this.isAggregatedLayer()) {
              query.having.splice(columnIndex, 1)
            } else {
              query.rules[groupIndex].rules.splice(columnIndex, 1)
            }
          }
        }
        if (this.useGroupBy() && !this.isAggregatedLayer()) {
          query.having.push(rule)
        } else {
          query.rules.push(rule)
        }
        return columnIndex === -1
      } catch (e) {
        console.log(e)
        return null
      }
      */
    },
    addPkRule: function (pk, groupBy = false, geoLevelBase= -1) {
      if (!pk) throw new Error('pk não inicializada')

      const condition = {
        'not': false,
        'rules': [
          {
            id: pk.objectId,
            isSystem: true,
            useAlias: true,
            useInternalName: false,
            value: 0,
            operator: 'is_not_null',
            'geoLevelId': geoLevelBase
          }
        ],
        'valid': true,
        'condition': 'AND'
      }
      const query = {
        'Geoserver': {},
        'Postgresql': {
          'not': false,
          'rules': [],
          'valid': true,
          'having': [],
          'select': [
            {
              'id': pk.objectId,
              'useAlias': false,
              'useInternalName': false,
              'isSystem': true
            }
          ],
          'tables': [],
          'dialect': 'Postgresql',
          'groupBy': [],
          'condition': 'AND',
          'spatialFilters': []
        }
      }


      query.Postgresql.rules.push(condition)
      console.log(JSON.stringify(query.Postgresql))

      return {query: query}
    },
    addPkRule2: function (layer = null, pk,geoLevelBase = -1) {
      layer = layer === null ? this.baseLayer : layer
      const condition = {
        'not': false,
        'rules': [
          {
            id: pk.objectId,
            isSystem: true,
            useAlias: false,
            useInternalName: false,
            value: 0,
            operator: 'greater',
            'geoLevelId': geoLevelBase
          }
        ],
        'valid': true,
        'condition': 'AND'
      }
      layer.jbQuery.query.Postgresql.select.push(condition)
    },
    /**
     * Add a column to select clause
     *
     * @function addSelectExpression
     * @param {Object} expression - Expression
     * @param {Object} query - Rule Json Pattern
     * @param {Boolean} isSystem - Append by system
     * @return {Boolean} true if has success otherwise false
     * @param {string} aggregation - Aggregation function name
     */
    addSelectExpression: function (expression, query = null, isSystem = true, aggregation = 'none', layerTarget = null) {
      layerTarget = layerTarget === null ? this.baseLayer : layerTarget
      if (!R.is(Object, expression)) throw new Error('Esperado um objeto contendo a expressão')
      if (query === null && !this.baseHasFilter()) throw new Error(`BaseLayer não é filtro: Impossível continuar`)
      if (query === null) query = this.baseLayer.jbQuery.query.Postgresql
      try {
        let foundKey = expression.hasOwnProperty('id') ? expression.id : expression.objectId
        foundKey = expression.hasOwnProperty('targetId') && expression.targetId !== -1 ? expression.targetId : foundKey
        const columnIndex = query.select.findIndex(c => c.id === foundKey)
        if (columnIndex === -1) {
          const column = {
            'id': foundKey,
            'useAlias': false,
            'aggregation': aggregation,
            'useInternalName': true,
            'isSystem': isSystem
          }
          query.select.push(column)
        }

        if (this.isPolygon(layerTarget) && !this.isAggregatedLayer(layerTarget) && !this.isGridLayer(layerTarget)) {
          const groupIndex = query.groupBy.findIndex(c => c.id === expression.objectId)
          if (groupIndex === -1) {
            let group = {
              'id': expression.objectId,
              'useAlias': false,
              'aggregation': 'none',
              'useInternalName': false,
              'isSystem': isSystem
            }
            query.groupBy = [group]
          }
        }
        return columnIndex === -1
      } catch (e) {
        console.log(e)
        return null
      }
    },
    addSpatialFilter: function (rule, query = null) {
      if (!R.is(Object, rule)) throw new Error('Esperado um objeto contendo a rule')
      if (query === null && !this.baseHasFilter()) throw new Error(`BaseLayer não é filtro: Impossível continuar`)
      if (query === null) query = this.baseLayer.jbQuery.query.Postgresql
      try {
        let columnIndex = -1
        let groupIndex = 0
        let groupRulesLength = 0
        const rules = query.rules
        for (let i = 0; i < rules.length; i++) {
          let group = rules[i]
          // columnIndex = group.rules.findIndex(c => c.id === rule.rules[0].id && c.type === 'geometry' && c.flow === rule.flow)
          columnIndex = group.rules.findIndex(c => c.id === rule.rules[0].id && c.type === 'geometry' && c.flow === rule.rules[0].flow)
          if (columnIndex !== -1) {
            groupIndex = i
            groupRulesLength = group.rules.length
          }
        }
        if (columnIndex !== -1) {
          console.info(`Coluna de geometria já existe na coleção: ${columnIndex}`)
          // TODO Revisar comportamento para múltiplos filtros espaciais (Ferraz)
          rule.rules.forEach(function (rule) {
            query.rules[groupIndex].rules.push(rule)
          })
          /*
          if (groupRulesLength === 1) {
            // query.rules.splice(groupIndex, 1)
            query.rules[groupIndex].rules.push(rule.rules)
          } else {
            // query.rules[groupIndex].rules.splice(columnIndex, 1)
            query.rules[groupIndex].rules.push(rule.rules)
          }
          */
        } else {
          query.rules.push(rule)
        }
        return columnIndex === -1
      } catch (e) {
        console.log(e)
        return null
      }
    },
    addGroupExpression: function (expression, query = null, isSystem = true) {
      if (!R.is(Object, expression)) throw new Error('Esperado um objeto contendo a expressão')
      if (query === null && !this.baseHasFilter()) throw new Error(`BaseLayer não é filtro: Impossível continuar`)
      if (query === null) query = this.baseLayer.jbQuery.query.Postgresql
      try {
        if (typeof query.groupBy === 'undefined') query.groupBy = []
        const foundKey = expression.hasOwnProperty('id') ? expression.id : expression.objectId
        const columnIndex = query.groupBy.findIndex(c => c.id === foundKey)
        if (columnIndex === -1) {
          const column = {
            'id': foundKey,
            'useAlias': false,
            'aggregation': 'none',
            'isSystem': isSystem
          }
          query.groupBy.push(column)
        }
        return columnIndex === -1
      } catch (e) {
        console.log(e)
        return null
      }
    },
    /**
     * Add a rule to select clause
     *
     * @function addSelectRule
     * @param {Object} rule - Json rule
     * @param {Object} query - Rule Json Pattern
     * @return {Boolean} true if has success otherwise false
     */
    addSelectRule: function (rule, query = null) {
      if (!R.is(Object, rule)) throw new Error('Esperado um objeto contendo a rule')
      if (query === null && !this.baseHasFilter()) throw new Error(`BaseLayer não é filtro: Impossível continuar`)
      if (query === null) query = this.baseLayer.jbQuery.query.Postgresql
      const columnIndex = query.select.findIndex(c => c.alias === rule.alias || c.id === rule.id)
      if (columnIndex !== -1) query.select.splice(columnIndex, 1)
      query.select.push(rule)
      if (this.isPolygon()) {
        const groupIndex = query.groupBy.findIndex(c => c.id === this.basePk.objectId)
        if (groupIndex === -1) {
          let group = {
            'id': this.basePk.objectId,
            'useAlias': false,
            'aggregation': 'none',
            'useInternalName': false,
            'isSystem': true
          }
          query.groupBy = [group]
        }
      }
      return columnIndex === -1
    },
    baseHasFilter: function () {
      if (this.baseLayer === null) return false
      return this.baseLayer.jbQuery !== null &&
        this.baseLayer.jbQuery.hasOwnProperty('query') &&
        this.baseLayer.jbQuery.query.hasOwnProperty('Postgresql')
    },
    changeDataViz: async function () {
      return new Promise((resolve, reject) => {
        const environment = this.getEnvironmentId()
        this.layerService.changeDataViz(environment, this.baseLayer.gdIdEvent, this.nativeType).then((res) => {
          resolve(res)
        }, (error) => {
          reject(error)
        })
      })
    },
    generateUid: function () {
      return v4()
    },
    getBaseLayerUid: function () {
      return this.baseLayer.gdIdEvent === this.baseLayer.gdIdParent ? this.baseLayer.gdIdEvent : this.baseLayer.gdIdParent
    },
    getBasePk: function () {
      const self = this
      return new Promise((resolve, reject) => {
        const layerid = this.baseLayer.objectid
        self.layerService.getPrimaryKey(layerId).then((res) => {
          if (res.status >= 200 && res.status < 300) {
            resolve(res.data[0])
          } else {
            const message = res.data.message || res.data.msg || res.data || 'Não foi possível ler a chave primária'
            messenger.warn({position: 'top-end', title: message})
            reject(res.data)
          }
        }, (error) => {
          const message = res.data.message || res.data.msg || res.data || 'Não foi possível ler a chave primária'
          messenger.warn({position: 'top-end', title: message})
          reject(error)
        })
      })
    },
    getCounters: async function (layer, bounds = []) {
      return new Promise((resolve, reject) => {
        if (typeof layer === 'undefined') reject(new Error('Esperado o layer'))
        layer.renderMode = false
        const noQueryFilter = layer.jbQuery !== null && layer.jbQuery.hasOwnProperty('query')
        if (layer.cClass === 'native' || (layer.cClass === 'filter' && !noQueryFilter) || (layer.cClass === 'upload' && !noQueryFilter)) {
          this.dataService.GetEstimatedCount('default', layer.jbData.config.table).then((res) => {
            if (res.status == 200) {
              const tableKey = `default.${layer.jbData.config.table}`
              resolve(res.data.data[tableKey])
            } else if (res.status === 204) {
              reject(new Error('A consulta não retornou resultado'))
            } else {
              reject(new Error(res.data.message || 'Ops...algo deu errado'))
            }
          }, (error) => {
            reject(error)
          })
        } else {
          this.layerService.getRowCount(layer, bounds).then((res) => {
            try {
              if (res.status >= 200 && res.status < 300) {
                const count = res.data.count
                // if (count > 0) {
                resolve(count)
                // } else {
                //   reject(new Error('A consulta não retornou resultado'))
                // }
              } else {
                reject(new Error(res.data.message || 'Ops...algo deu errado'))
              }
            } catch (erro) {
              reject(new Error('A consulta não retornou resultado'))
            }
          }, (error) => {
            reject(error)
          })
        }
      })
    },
    getCountersObject: async function (layer, bounds = []) {
      const self = this;
      console.time('saveLayer');

      try {
        const data = await self.getCounters(layer, bounds);
        let objCounter = {
          rowCount: data,
          featureCount: data,
          dateCount: new Date().toLocaleDateString()
        };
        console.timeEnd('saveLayer');
        return objCounter;
      } catch (error) {
        messenger.error({position: 'center', title: error.message});
        console.log(error);
        console.timeEnd('saveLayer');
        throw error;
      }
    },
    getEnvironmentId: function () {
      return Vue.prototype.$foundation.getEnvironmentId()
    },
    getRelationshipProperty: function (layer, propertyName) {
      if (!this.isEnrichedLayer(layer)) throw new Error('O layer não é enriquecido')
      if (typeof layer === 'undefined') throw new Error('Esperada a instância do layer')
      if (!layer.hasOwnProperty('cClass')) throw new Error('"cClass" inexistente na instância do layer')
      if (typeof propertyName === 'undefined' || propertyName === null || propertyName.length <= 0) {
        throw new Error("Esperado o nome da propriedade: 'propertyName'")
      }
      // if (!layer.jbData.config.hasOwnProperty('metadata')) throw new Error("O layer não possui relacionamento")
      const relationship = this.baseLayer.jbData.config.metadata.relationship
      return relationship[propertyName]
    },
    getTargetPk: function () {
      const self = this
      return new Promise((resolve, reject) => {
        const layerId = this.targetLayer.objectid
        self.layerService.getPrimaryKey(layerId).then((res) => {
          if (res.status >= 200 && res.status < 300) {
            resolve(res.data[0])
          } else {
            const message = res.data.message || res.data.msg || res.data || 'Não foi possível ler a chave primária'
            messenger.warn({position: 'top-end', title: message})
            reject(res.data)
          }
        }, (error) => {
          const message = res.data.message || res.data.msg || res.data || 'Não foi possível ler a chave primária'
          messenger.warn({position: 'top-end', title: message})
          reject(error)
        })
      })
    },
    getTemplateColumns: async function (classType, alwaysOnTop = 0) {
      return new Promise((resolve, reject) => {
        const self = this
        let environmentId = this.getEnvironmentId()
        this.templateService.getTemplate(self.baseLayer.objectid, environmentId, classType, alwaysOnTop).then((res) => {
          resolve(res)
        }, (error) => {
          reject(error)
        })
      })
    },
    eventHandlers: function () {

    },
    getAnotherLevel: function (targetLayers) {
      const dataViz = this.baseLayer.jbData.config.datavis
      if (dataViz.options && !dataViz.options.layer.isSameLevel) {
        return targetLayers.find(x => x.gdIdEvent === dataViz.options.layer.alias)
      }
      return this.baseLayer
    },
    getNativeType: function () {
      return !this.useGroupBy() ? this.baseLayer.jbData.config.datavis.native : this.targetLayer.jbData.config.datavis.native
    },
    isAggregatedLayer: function (layer = null) {
      try {
        layer = layer === null ? this.baseLayer : layer

        let objLayer = null
        if (layer.jbData == undefined || layer.jbData == null)
          if (layer.object == undefined || layer.object == null) {
            objLayer = layer.layer
          } else
            objLayer = layer.object.layer
        else
          objLayer = layer

        const dataVis = objLayer.jbData.config.datavis
        if (dataVis.hasOwnProperty('aggregated')) {
          return dataVis.aggregated
        }
        return false
      } catch (e) {
        return false
      }
    },
    isGridLayer: function (layer = null) {
      layer = layer === null ? this.baseLayer : layer
      return this.isGridType(layer) || this.hasHighDensity(layer)
    },
    isGridType: function (layer = null) {
      layer = layer === null ? this.baseLayer : layer
      // const dataVis = layer.jbData.config.datavis
      const dataVis = typeof layer.jbData !== 'undefined' ? layer.jbData.config.datavis : null
      let gridTypes = dataVis != null ? MapConstants.GridTypes.includes(dataVis.type) : null
      return gridTypes
    },
    isEmptyObject: function (obj = {}) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    },
    /**
     * Indicates if the layer is enriched
     *
     * @function isEnrichedLayer
     * @return {Boolean} true, if layer is enriched, otherwise, false
     */
    isEnrichedLayer: function (layer = null) {
      try {
        layer = layer === null ? this.baseLayer : layer
        return layer.jbData.config.hasOwnProperty('metadata') &&
          layer.jbData.config.metadata.hasOwnProperty('relationship') &&
          layer.jbData.config.metadata.relationship !== 'None'
      } catch (e) {
        return false
      }

    },
    /**
     * @function isGeoPopLayer Indicates if the layer is GeoPop
     * @param layer - Layer instance
     * @return {Boolean} true, if layer is GeoPop Layer, otherwise, false
     */
    isGeoPopLayer: function (layer = null) {
      const geoLevels = this.$store.getters['layer/getGeoPopLevels']
      //return true
      layer = layer === null ? this.baseLayer : layer
      
      if (geoLevels.length === 0) throw new Error(`Esperada uma coleção de GeoLevels na sessão`)
      return geoLevels.some(l => l.hasOwnProperty('mapLayer') && l.mapLayer !== null && l.mapLayer.layerUid === layer.gdIdParent)
    },
    /**
     * Indicates if the layer is a upload of the GeoPop
     *
     * @function isGeoPopUpload
     * @return {Boolean} true, if layer is GeoPop Upload, otherwise, false
     */
    isGeoPopUpload: function () {
      if (this.baseLayer.cClass !== 'upload') return false
      const self = this
      const geoLevels = this.$store.getters['layer/getGeoPopLevels']
      if (geoLevels.length === 0) throw new Error(`Esperada uma coleção de GeoLevels na sessão`)
      if (self.isEnrichedLayer()) {
        const relationship = self.baseLayer.jbData.config.metadata.relationship
        const findKey = relationship.layer
        const geoLevel = geoLevels.find(l => l.hasOwnProperty('mapLayer') && l.mapLayer !== null && l.mapLayer.layerUid === findKey)
        return (typeof geoLevel !== 'undefined')
      }
      return false
    },
    isValidZ: function () {
      const z = mapActions.getZoom('baseMap')
      return z < this.zoomThreshold
    },
    /**
     * @function hasHighDensity
     * @param layer - Layer instance
     * @param rowCount - Row Count object
     * @returns {boolean}
     */
    hasHighDensity: function (layer = null, rowCount = {}) {
      layer = layer === null ? this.baseLayer : layer
      const dataVis = typeof layer.jbData !== 'undefined' ? layer.jbData.config.datavis : null
      const counters = dataVis != null && this.isEmptyObject(rowCount) ? layer.jbData.config.rowCount : rowCount
      const maxFeatures = dataVis.hasOwnProperty('maxFeaturesValue') ? dataVis.maxFeaturesValue : dataVis.maxFeatures
      const featureCount = counters.hasOwnProperty('featureCount') ? counters.featureCount : 0
      return parseFloat(maxFeatures) > 0 && parseFloat(maxFeatures) < parseFloat(featureCount)
    },
    internalHandleEvents: function () { },
    isLineString: function () {
      if (this.baseLayer === null) return false
      return this.baseLayer.jbData.config.datavis.native === 'line'
    },
    isPoint: function () {
      if (this.baseLayer === null) return false
      return this.baseLayer.jbData.config.datavis.native === 'circle'
    },
    isPointToPoint: function () {
      if (this.targetLayer === null) return false
      const dataVis = this.baseLayer.jbData.config.datavis
      const dataVis2 = this.targetLayer.jbData.config.datavis
      return dataVis.native === 'circle' && dataVis2.native === 'circle'
    },
    isPointToPolygon: function () {
      if (this.targetLayer === null) return false
      const dataVis = this.baseLayer.jbData.config.datavis
      const dataVis2 = this.targetLayer.jbData.config.datavis
      return dataVis.native === 'circle' && dataVis2.native === 'fill'
    },
    isPolygon: function (layer) {
      try {
        layer = layer === undefined || layer === null ? this.baseLayer : layer
        let objLayer = null
        if (layer.jbData == undefined || layer.jbData == null)
          if (layer.object == undefined || layer.object == null) {
            objLayer = layer.layer
          } else
            objLayer = layer.object.layer
        else
          objLayer = layer

        if (objLayer === null) return false
        return objLayer.jbData.config.datavis.native === 'fill'
      } catch (e) {
        return false
      }
    },
    isPolygonalFilter: function () {
      const dataVis = this.baseLayer.jbData.config.datavis
      if (!dataVis.hasOwnProperty('options')) return false
      if (dataVis.options === null) return false
      return !dataVis.options.layer.isSameLevel && dataVis.options.layer.type === 'fill'
    },
    isSameGeoLevel: function () {
      const self = this
      return new Promise((resolve, reject) => {
        if (self.baseLayer === null) reject(new Error('baseLayer não definido'))
        if (self.targetLayer === null) reject(new Error('targetLayer não definido'))
        if (self.basePk === null) reject(new Error('basePk não definida'))
        if (self.targetPk === null) reject(new Error('targetPk não definida'))
        resolve(self.basePk.tableRelation.geoLevelId === self.targetPk.tableRelation.geoLevelId)
      })
    },
    isLine: function (layer) {
      layer = layer === undefined || layer === null ? this.baseLayer : layer
      let objLayer =null
      if(layer.jbData ==undefined || layer.jbData == null)
        if(layer.object ==undefined || layer.object == null){
          objLayer = layer.layer
        }else
        objLayer = layer.object.layer
      else
        objLayer = layer

      if (objLayer === null) return false
      return objLayer.jbData.config.datavis.native === 'line'
    },
    isSymbol: function () {
      if (this.baseLayer === null) return false
      return this.baseLayer.jbData.config.datavis.native === 'symbol'
    },
    isHybridMode: function () {
      const dataVis = this.baseLayer.jbData.config.datavis
      return dataVis.type === 'cluster' && dataVis.hasOwnProperty('hybridMode') ? dataVis.hybridMode : true
    },
    onBaseLayerChanged: function (layer) {
      if (layer.cClass === 'userdraw') return
      const self = this
      const layerId = (layer === null || layer === undefined) ? this.baseLayer.objectId : layer.objectId

      self.layerService.getPrimaryKey(layerId).then((res) => {
        if (res.status >= 200 && res.status < 300) {
          self.basePk = res.data[0]
        } else if (res.status === 400) {
          const message = res.data.message || res.data.msg || 'Não foi possível ler a chave primária'
          messenger.error({position: 'top-end', title: message})
        } else if (res.status === 404) {
          const message = res.data.message || res.data.msg || res.data || 'Não foi possível ler a chave primária'
          messenger.warn({position: 'top-end', title: message})
        }
      }, (error) => {
        console.log(error)
        messenger.error({position: 'top-end', title: error.message})
      })
    },
    targetLayerChanged: function (layer) {
      this.$root.$emit('targetLayerChanged', {layer: layer})
    },
    readStyleFromServer: function (styleType = 'cluster') {
      const self = this
      return new Promise((resolve, reject) => {
        const layerUid = this.useGroupBy() && !this.isAggregatedLayer() ? this.targetLayer.gdIdEvent : this.baseLayer.gdIdEvent
        // const styleType = this.useGroupBy() ? this.targetLayer.jbData.config.datavis.native : this.nativeType
        self.dataVizService.getStyle(layerUid, styleType).then((res) => {
          resolve(res)
        }, (error) => {
          reject(error)
        })
      })
    },
    /**
     * Remove column from select clause
     *
     * @function removeQueryColumn
     * @param {Object} expression - Expression
     * @param {Object} query - Rule Json Pattern
     * @return {Boolean} true if has success otherwise false
     */
    removeSelectExpression: function (expression, query = null) {
      if (!R.is(Object, expression)) throw new Error('Esperado um objeto contendo a expressão')
      if (query === null && !this.baseHasFilter()) throw new Error(`BaseLayer não é filtro: Impossível continuar`)
      if (query === null) query = this.baseLayer.jbQuery.query.Postgresql
      try {
        let foundKey = expression.hasOwnProperty('id') ? expression.id : expression.objectId
        foundKey = expression.hasOwnProperty('targetId') && expression.targetId !== -1 ? expression.targetId : foundKey
        const columnIndex = query.select.findIndex(c => c.id === foundKey)
        if (columnIndex !== -1) query.select.splice(columnIndex, 1)
        if (this.isPolygon() && query.select.length === 1) {
          const groupIndex = query.groupBy.findIndex(c => c.id === this.basePk.objectId)
          if (groupIndex !== -1) query.groupBy.splice(groupIndex, 1)
        }
        return (columnIndex !== -1)
      } catch (e) {
        console.log(e)
        return false
      }
    },
    reSyncLayers: function (layer, layer2) {
      if (!layer) throw new Error('Esperado o layer base')
      // this.layerType = layer.jbData.config.datavis.type || 'cluster'
      this.nativeType = layer.jbData.config.datavis.native || 'circle'
      this.baseLayer = layer
      this.targetLayer = layer2 || layer
    },
    syncLayers: function () {
      const layer = this.layer.object.layer
      const layer2 = this.layer2 !== null ? this.layer2.object.layer : null
      // this.layerType = layer.jbData.config.datavis.type || 'cluster'
      this.nativeType = layer.jbData.config.datavis.native || 'circle'
      this.baseLayer = layer
      this.targetLayer = layer2 || layer
    },
    save: async function (parent, expressions, name) {
      return new Promise((resolve, reject) => {
        if (typeof parent === 'undefined') reject(new Error('Esperado o identificador do layer pai'))
        if (typeof expressions === 'undefined') reject(new Error('Esperado o objeto "expressions"'))
        if (typeof name === 'undefined') reject(new Error('Esperado o nome do filtro'))
        let gdIdEvent = Vue.prototype.$foundation.getUniqueId()
        let layer = queryBuilder.buildLayerPattern(gdIdEvent, parent, name, expressions)
        this.layerService.create(layer).then((res) => {
          resolve(layer)
        }, (error) => {
          reject(error)
        })
      })
    },
    showOnMap: async function (mapKey, layer, parent, table, where, datavis = 'cluster', clusterSampleSize = 100000) {
      return new Promise((resolve, reject) => {
        if (typeof mapKey === 'undefined') reject(new Error('Esperado o identificador do mapa'))
        if (typeof layer === 'undefined') reject(new Error('Esperado o identificador do layer'))
        if (typeof parent === 'undefined') reject(new Error('Esperado o identificador do layer pai'))
        this.dataVizService.getStyle(parent, datavis).then((res) => {
          const options = {
            'mapKey': mapKey,
            'schema': 'default',
            'table': table,
            'layer': layer,
            'parent': parent,
            'where': where,
            'datavis': {'type': datavis, 'style': res.data},
            'sampleRate': clusterSampleSize,
            'enabled': true,
            'extent': 128,
            'clusterOptions': {
              'flyTo': true,
              'showInfo': true,
              'radius': 40,
              'minZoom': 0,
              'maxZoom': (where !== null ? 15 : 17),
              'style:': ''
            }
          }
          mapActions.addLayer(options)
          if (mapActions.zoomIsOutOfRange(options)) {
            messenger.warn({
              position: 'top-end',
              title: `Camada fora do nível de zoom: ${res.data.minzoom}`,
              timer: 3500
            })
          }
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    targetHasFilter: function () {
      if (this.targetLayer === null) return false
      return this.targetLayer.jbQuery !== null &&
        this.targetLayer.jbQuery.hasOwnProperty('query') &&
        this.targetLayer.jbQuery.query.hasOwnProperty('Postgresql')
    },
    /**
     * Toggle cluster visualization mode
     *
     * @async
     * @function toggleMode
     * @param {boolean} hybridMode -  true, if is HybridMode, else false
     * @return {Promise<json>} true | false
     */
    toggleHybridMode: async function (hybridMode = true) {
      return new Promise((resolve, reject) => {
        let environment = this.getEnvironmentId()
        let config = {
          'type': 'cluster',
          'hybridMode': hybridMode,
          'options': null,
          'modified': new Date().toLocaleDateString()
        }
        this.layerService.updateConfig(this.baseLayer.objectid, environment, 'datavis', config).then((res) => {
          this.baseLayer.jbData.config.datavis.hybridMode = hybridMode
          resolve(hybridMode)
        }, (error) => {
          reject(error)
        })
      })
    },
    updateConfig: async function (config) {
      return new Promise((resolve, reject) => {
        if (typeof config === 'undefined') reject(new Error('Esperado o objeto de configuração'))
        let environment = this.getEnvironmentId()
        this.layerService.updateConfig(this.baseLayer.objectid, environment, 'datavis', config).then((res) => {
          resolve(res)
        }, (error) => {
          reject(error)
        })
      })
    },
    updateCustomStyles: async function (styleObjects) {
      try {
        let listStyle = []
        for (const row of styleObjects) {
          let style = {
            "tag": row.type,
            "guid": this.baseLayer.gdIdEvent,
            "style": JSON.stringify(row.style)
          }
          listStyle.push(style)
        }
        return new Promise((resolve, reject) => {
          this.dataVizService.updateCustomStyles(listStyle).then((res) => {
            resolve(res)
          }, (error) => {
            reject(error)
          })
        })
      } catch (e) {
        console.error({"title":'Erro ao atualizar Estilos',"error":e })
      }
    },


    updateCustomStyle: async function (datavis, style) {
      return new Promise((resolve, reject) => {
        this.dataVizService.updateCustomStyle(this.baseLayer.gdIdEvent, datavis, style).then((res) => {
          resolve(res)
        }, (error) => {
          reject(error)
        })
      })
    },
    useGroupBy: function () {
      if (this.baseLayer.gdIdParent === this.gdIdEventSetor) return true
      if (this.baseLayer.jbData.config.datavis.native === 'fill' && this.baseLayer.gdIdParent !== this.gdIdEventSetor) return true
      if (this.targetLayer === null || this.targetLayer === undefined) return false
      if (this.baseLayer.objectid === this.targetLayer.objectid) return false
      if (this.baseLayer.jbData.config.datavis.native !== this.targetLayer.jbData.config.datavis.native) return true
      if (this.baseLayer.gdIdParent === this.targetLayer.gdIdEvent) return false
      return this.baseLayer.gdIdParent !== this.targetLayer.gdIdEvent
    },
    useGroupBy2: function (layer1, layer2) {
      if (!layer1) throw new Error('Esperado layer1')
      if (layer1.gdIdParent === this.gdIdEventSetor) return true
      if (layer1.jbData.config.datavis.native === 'fill' && layer1.gdIdParent !== this.gdIdEventSetor) return true
      if (layer2 === null || layer2 === undefined) return false
      if (layer1.objectid === layer2.objectid) return false
      if (layer1.jbData.config.datavis.native !== layer2.jbData.config.datavis.native) return true
      if (layer1.gdIdParent === layer2.gdIdEvent) return false
      return layer1.gdIdParent !== layer2.gdIdEvent
    }
  },
  props: {
    layer: {
      type: Object,
      default:
        null
    },
    layer2: {
      type: Object,
      default:
        null
    }
  }
}
